'use client'
import React, { Suspense } from 'react';
import Image from 'next/image';
const Countupcards = React.lazy(() => import('@/ui/Countupcards'));
const ApplyNow = React.lazy(() => import('@/ui/ApplyNow'));

const NEPCompliance = ({ title }) => {

    const impactData = [
        {
            icon: "Users",
            value: "Integration of Vocational Skills",
            label: "Curriculum aligned to industry skills through on job learning at internship, apprenticeships",
        },
        {
            icon: "Handshake",
            value: "Multidisciplinary Learning",
            label: "Skill Electives (Skill Drill) and Professional Minor Electives along with Major to explore and develop competencies in diverse domains.",
        },
        {
            icon: "MapPin",
            value: "Holistic Development",
            label: "Emphasis on Communication skills, Life skills, Value based courses, and Technology for the all-around growth.",
        },
        {
            icon: "Award",
            value: "Multiple Entry/Exit",
            label: "Opportunities for early joiners at the workforce for an exit and re-entry at the relevant semester to continue to the next level.",
        },
        {
            icon: "TrendingUp",
            value: "Outcome-Based Education",
            label: "With focus on outcomes at Programme, Course, and Topic level for a productive learning mapped assessment.",
        },
        {
            icon: "Briefcase",
            value: "Continuous Assessment",
            label: "Technology is extensively integrated into teaching and learning to overcome language barriers and enhance educational planning and management.",
        },
        {
            icon: "Briefcase",
            value: "Digital-learning Ecosystem",
            label: "Integration of Technology with teaching and learning to enhance the experience in order to meet the future.",
        },
        {
            icon: "Briefcase",
            value: "Teacher’s Training",
            label: "Upskilling/Reskilling programs and workshops focused on several aspects of development for teaching professionals to evolve as Ambassadors for future of education and skilling.",
        },
        {
            icon: "Briefcase",
            value: "Employability",
            label: "With emphasis on industry relevant skills mapped to the curriculum and practical learning to assure employability.",
        },
        {
            icon: "Briefcase",
            value: "Unifying Academic and Vocational Tracks",
            label: "Paving the way to create pathway of progression in Academics for youth with vocational tracks and work experience.",
        },
    ];

    return (
        <>
            <section className="w-full block md:flex justify-center mb-4 sm:mb-8 md:mb-14 lg:mb-20">
                <div className='max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto'>
                    <div className='w-full mt-4 md:mt-8 lg:mt-12'>
                        <h2 className={` w-full md:w-[85%] lg:w-[90%] font-extrabold text-[clamp(20px,3vw,42px)] 
                          text-black leading-normal`}>MSU’s NEP 2020 Compliance Framework</h2>
                        <p className='text-md mb-4 md:mb-8 lg:mb-10'>Our academic model aligned with the National Education Policy to deliver future-ready, flexible, and outcome-based education.</p>
                        <Suspense
                            fallback={
                                <div className="mt-10 text-center w-full col-span-4">
                                    <span className="animate-pulse text-gray-400">
                                        Loading steps...
                                    </span>
                                </div>
                            }
                        >
                            <div className="mt-10 grid md:grid-cols-3 grid-cols-2 gap-6 xl:gap-8 w-full">
                                {impactData.map((item, index) => (
                                    <Countupcards
                                        key={index}
                                        icon={item.icon}
                                        value={item.value}
                                        label={item.label}
                                        delay={index * 0.08}
                                    />
                                ))}
                            </div>
                        </Suspense>
                    </div>
                </div>
            </section>
            <ApplyNow />
        </>
    )
}

export default NEPCompliance